// import IbBadge from './IbBadge'
import { Badge as IbBadge } from '@wow/badge'

export default IbBadge
